function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { createModalNotReadyError as e, createURL as t, createDuplicateIframeWarning as r, ViewController as n, createSDK as o, SDKBase as i } from "@magic-sdk/provider";
export * from "@magic-sdk/commons";
var a = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function u(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function c(e) {
  var t = {
    exports: {}
  };
  return e(t, t.exports), t.exports;
}

function f(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets option of @rollup/plugin-commonjs appropriately for this require call to behave properly.');
}

c(function (e) {
  var t = function (e) {
    var t,
        r = Object.prototype,
        n = r.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        u = o.toStringTag || "@@toStringTag";

    function c(e, t, r, n) {
      var o = Object.create((t && t.prototype instanceof y ? t : y).prototype),
          i = new N(n || []);
      return o._invoke = function (e, t, r) {
        var n = s;
        return function (o, i) {
          if (n === d) throw new Error("Generator is already running");

          if (n === h) {
            if ("throw" === o) throw i;
            return x();
          }

          for (r.method = o, r.arg = i;;) {
            var a = r.delegate;

            if (a) {
              var u = E(a, r);

              if (u) {
                if (u === v) continue;
                return u;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === s) throw n = h, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = d;
            var c = f(e, t, r);

            if ("normal" === c.type) {
              if (n = r.done ? h : l, c.arg === v) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }

            "throw" === c.type && (n = h, r.method = "throw", r.arg = c.arg);
          }
        };
      }(e, r, i), o;
    }

    function f(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    e.wrap = c;
    var s = "suspendedStart",
        l = "suspendedYield",
        d = "executing",
        h = "completed",
        v = {};

    function y() {}

    function p() {}

    function m() {}

    var b = {};

    b[i] = function () {
      return this;
    };

    var g = Object.getPrototypeOf,
        _ = g && g(g(O([])));

    _ && _ !== r && n.call(_, i) && (b = _);
    var w = m.prototype = y.prototype = Object.create(b);

    function I(e) {
      ["next", "throw", "return"].forEach(function (t) {
        e[t] = function (e) {
          return this._invoke(t, e);
        };
      });
    }

    function S(e, t) {
      function r(o, i, a, u) {
        var c = f(e[o], e, i);

        if ("throw" !== c.type) {
          var s = c.arg,
              l = s.value;
          return l && "object" == _typeof(l) && n.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
            r("next", e, a, u);
          }, function (e) {
            r("throw", e, a, u);
          }) : t.resolve(l).then(function (e) {
            s.value = e, a(s);
          }, function (e) {
            return r("throw", e, a, u);
          });
        }

        u(c.arg);
      }

      var o;

      this._invoke = function (e, n) {
        function i() {
          return new t(function (t, o) {
            r(e, n, t, o);
          });
        }

        return o = o ? o.then(i, i) : i();
      };
    }

    function E(e, r) {
      var n = e.iterator[r.method];

      if (n === t) {
        if (r.delegate = null, "throw" === r.method) {
          if (e.iterator.return && (r.method = "return", r.arg = t, E(e, r), "throw" === r.method)) return v;
          r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var o = f(n, e.iterator, r.arg);
      if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, v;
      var i = o.arg;
      return i ? i.done ? (r[e.resultName] = i.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, v) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, v);
    }

    function j(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function A(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function N(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(j, this), this.reset(!0);
    }

    function O(e) {
      if (e) {
        var r = e[i];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var o = -1,
              a = function r() {
            for (; ++o < e.length;) {
              if (n.call(e, o)) return r.value = e[o], r.done = !1, r;
            }

            return r.value = t, r.done = !0, r;
          };

          return a.next = a;
        }
      }

      return {
        next: x
      };
    }

    function x() {
      return {
        value: t,
        done: !0
      };
    }

    return p.prototype = w.constructor = m, m.constructor = p, m[u] = p.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : (e.__proto__ = m, u in e || (e[u] = "GeneratorFunction")), e.prototype = Object.create(w), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, I(S.prototype), S.prototype[a] = function () {
      return this;
    }, e.AsyncIterator = S, e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new S(c(t, r, n, o), i);
      return e.isGeneratorFunction(r) ? a : a.next().then(function (e) {
        return e.done ? e.value : a.next();
      });
    }, I(w), w[u] = "Generator", w[i] = function () {
      return this;
    }, w.toString = function () {
      return "[object Generator]";
    }, e.keys = function (e) {
      var t = [];

      for (var r in e) {
        t.push(r);
      }

      return t.reverse(), function r() {
        for (; t.length;) {
          var n = t.pop();
          if (n in e) return r.value = n, r.done = !1, r;
        }

        return r.done = !0, r;
      };
    }, e.values = O, N.prototype = {
      constructor: N,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(A), !e) for (var r in this) {
          "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var r = this;

        function o(n, o) {
          return u.type = "throw", u.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i],
              u = a.completion;
          if ("root" === a.tryLoc) return o("end");

          if (a.tryLoc <= this.prev) {
            var c = n.call(a, "catchLoc"),
                f = n.call(a, "finallyLoc");

            if (c && f) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            } else if (c) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            } else {
              if (!f) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];

          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(a);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), A(r), v;
        }
      },
      catch: function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];

          if (r.tryLoc === e) {
            var n = r.completion;

            if ("throw" === n.type) {
              var o = n.arg;
              A(r);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, r, n) {
        return this.delegate = {
          iterator: O(e),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = t), v;
      }
    }, e;
  }(e.exports);

  try {
    regeneratorRuntime = t;
  } catch (e) {
    Function("r", "regeneratorRuntime = r")(t);
  }
});
var s = c(function (e, t) {
  e.exports = function e(t, r, n) {
    function o(a, u) {
      if (!r[a]) {
        if (!t[a]) {
          if (!u && f) return f(a);
          if (i) return i(a, !0);
          var c = new Error("Cannot find module '" + a + "'");
          throw c.code = "MODULE_NOT_FOUND", c;
        }

        var s = r[a] = {
          exports: {}
        };
        t[a][0].call(s.exports, function (e) {
          return o(t[a][1][e] || e);
        }, s, s.exports, e, t, r, n);
      }

      return r[a].exports;
    }

    for (var i = f, a = 0; a < n.length; a++) {
      o(n[a]);
    }

    return o;
  }({
    1: [function (e, t, r) {
      (function (e) {
        var r,
            n,
            o = e.MutationObserver || e.WebKitMutationObserver;

        if (o) {
          var i = 0,
              a = new o(s),
              u = e.document.createTextNode("");
          a.observe(u, {
            characterData: !0
          }), r = function r() {
            u.data = i = ++i % 2;
          };
        } else if (e.setImmediate || void 0 === e.MessageChannel) r = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function () {
          var t = e.document.createElement("script");
          t.onreadystatechange = function () {
            s(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
          }, e.document.documentElement.appendChild(t);
        } : function () {
          setTimeout(s, 0);
        };else {
          var c = new e.MessageChannel();
          c.port1.onmessage = s, r = function r() {
            c.port2.postMessage(0);
          };
        }

        var f = [];

        function s() {
          var e, t;
          n = !0;

          for (var r = f.length; r;) {
            for (t = f, f = [], e = -1; ++e < r;) {
              t[e]();
            }

            r = f.length;
          }

          n = !1;
        }

        t.exports = function (e) {
          1 !== f.push(e) || n || r();
        };
      }).call(this, void 0 !== a ? a : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {}],
    2: [function (e, t, r) {
      var n = e(1);

      function o() {}

      var i = {},
          a = ["REJECTED"],
          u = ["FULFILLED"],
          c = ["PENDING"];

      function f(e) {
        if ("function" != typeof e) throw new TypeError("resolver must be a function");
        this.state = c, this.queue = [], this.outcome = void 0, e !== o && h(this, e);
      }

      function s(e, t, r) {
        this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
      }

      function l(e, t, r) {
        n(function () {
          var n;

          try {
            n = t(r);
          } catch (t) {
            return i.reject(e, t);
          }

          n === e ? i.reject(e, new TypeError("Cannot resolve promise with itself")) : i.resolve(e, n);
        });
      }

      function d(e) {
        var t = e && e.then;
        if (e && ("object" == _typeof(e) || "function" == typeof e) && "function" == typeof t) return function () {
          t.apply(e, arguments);
        };
      }

      function h(e, t) {
        var r = !1;

        function n(t) {
          r || (r = !0, i.reject(e, t));
        }

        function o(t) {
          r || (r = !0, i.resolve(e, t));
        }

        var a = v(function () {
          t(o, n);
        });
        "error" === a.status && n(a.value);
      }

      function v(e, t) {
        var r = {};

        try {
          r.value = e(t), r.status = "success";
        } catch (e) {
          r.status = "error", r.value = e;
        }

        return r;
      }

      t.exports = f, f.prototype.catch = function (e) {
        return this.then(null, e);
      }, f.prototype.then = function (e, t) {
        if ("function" != typeof e && this.state === u || "function" != typeof t && this.state === a) return this;
        var r = new this.constructor(o);
        return this.state !== c ? l(r, this.state === u ? e : t, this.outcome) : this.queue.push(new s(r, e, t)), r;
      }, s.prototype.callFulfilled = function (e) {
        i.resolve(this.promise, e);
      }, s.prototype.otherCallFulfilled = function (e) {
        l(this.promise, this.onFulfilled, e);
      }, s.prototype.callRejected = function (e) {
        i.reject(this.promise, e);
      }, s.prototype.otherCallRejected = function (e) {
        l(this.promise, this.onRejected, e);
      }, i.resolve = function (e, t) {
        var r = v(d, t);
        if ("error" === r.status) return i.reject(e, r.value);
        var n = r.value;
        if (n) h(e, n);else {
          e.state = u, e.outcome = t;

          for (var o = -1, a = e.queue.length; ++o < a;) {
            e.queue[o].callFulfilled(t);
          }
        }
        return e;
      }, i.reject = function (e, t) {
        e.state = a, e.outcome = t;

        for (var r = -1, n = e.queue.length; ++r < n;) {
          e.queue[r].callRejected(t);
        }

        return e;
      }, f.resolve = function (e) {
        return e instanceof this ? e : i.resolve(new this(o), e);
      }, f.reject = function (e) {
        var t = new this(o);
        return i.reject(t, e);
      }, f.all = function (e) {
        var t = this;
        if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
        var r = e.length,
            n = !1;
        if (!r) return this.resolve([]);

        for (var a = new Array(r), u = 0, c = -1, f = new this(o); ++c < r;) {
          s(e[c], c);
        }

        return f;

        function s(e, o) {
          t.resolve(e).then(function (e) {
            a[o] = e, ++u !== r || n || (n = !0, i.resolve(f, a));
          }, function (e) {
            n || (n = !0, i.reject(f, e));
          });
        }
      }, f.race = function (e) {
        if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
        var t = e.length,
            r = !1;
        if (!t) return this.resolve([]);

        for (var n = -1, a = new this(o); ++n < t;) {
          this.resolve(e[n]).then(function (e) {
            r || (r = !0, i.resolve(a, e));
          }, function (e) {
            r || (r = !0, i.reject(a, e));
          });
        }

        return a;
      };
    }, {
      1: 1
    }],
    3: [function (e, t, r) {
      (function (t) {
        "function" != typeof t.Promise && (t.Promise = e(2));
      }).call(this, void 0 !== a ? a : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {
      2: 2
    }],
    4: [function (e, t, r) {
      var n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      },
          o = function () {
        try {
          if ("undefined" != typeof indexedDB) return indexedDB;
          if ("undefined" != typeof webkitIndexedDB) return webkitIndexedDB;
          if ("undefined" != typeof mozIndexedDB) return mozIndexedDB;
          if ("undefined" != typeof OIndexedDB) return OIndexedDB;
          if ("undefined" != typeof msIndexedDB) return msIndexedDB;
        } catch (e) {
          return;
        }
      }();

      function i(e, t) {
        e = e || [], t = t || {};

        try {
          return new Blob(e, t);
        } catch (o) {
          if ("TypeError" !== o.name) throw o;

          for (var r = new ("undefined" != typeof BlobBuilder ? BlobBuilder : "undefined" != typeof MSBlobBuilder ? MSBlobBuilder : "undefined" != typeof MozBlobBuilder ? MozBlobBuilder : WebKitBlobBuilder)(), n = 0; n < e.length; n += 1) {
            r.append(e[n]);
          }

          return r.getBlob(t.type);
        }
      }

      "undefined" == typeof Promise && e(3);
      var a = Promise;

      function u(e, t) {
        t && e.then(function (e) {
          t(null, e);
        }, function (e) {
          t(e);
        });
      }

      function c(e, t, r) {
        "function" == typeof t && e.then(t), "function" == typeof r && e.catch(r);
      }

      function f(e) {
        return "string" != typeof e && (console.warn(e + " used as a key, but it is not a string."), e = String(e)), e;
      }

      function s() {
        if (arguments.length && "function" == typeof arguments[arguments.length - 1]) return arguments[arguments.length - 1];
      }

      var l = "local-forage-detect-blob-support",
          d = void 0,
          h = {},
          v = Object.prototype.toString,
          y = "readonly",
          p = "readwrite";

      function m(e) {
        for (var t = e.length, r = new ArrayBuffer(t), n = new Uint8Array(r), o = 0; o < t; o++) {
          n[o] = e.charCodeAt(o);
        }

        return r;
      }

      function b(e) {
        var t = h[e.name],
            r = {};
        r.promise = new a(function (e, t) {
          r.resolve = e, r.reject = t;
        }), t.deferredOperations.push(r), t.dbReady = t.dbReady ? t.dbReady.then(function () {
          return r.promise;
        }) : r.promise;
      }

      function g(e) {
        var t = h[e.name].deferredOperations.pop();
        if (t) return t.resolve(), t.promise;
      }

      function _(e, t) {
        var r = h[e.name].deferredOperations.pop();
        if (r) return r.reject(t), r.promise;
      }

      function w(e, t) {
        return new a(function (r, n) {
          if (h[e.name] = h[e.name] || {
            forages: [],
            db: null,
            dbReady: null,
            deferredOperations: []
          }, e.db) {
            if (!t) return r(e.db);
            b(e), e.db.close();
          }

          var i = [e.name];
          t && i.push(e.version);
          var a = o.open.apply(o, i);
          t && (a.onupgradeneeded = function (t) {
            var r = a.result;

            try {
              r.createObjectStore(e.storeName), t.oldVersion <= 1 && r.createObjectStore(l);
            } catch (r) {
              if ("ConstraintError" !== r.name) throw r;
              console.warn('The database "' + e.name + '" has been upgraded from version ' + t.oldVersion + " to version " + t.newVersion + ', but the storage "' + e.storeName + '" already exists.');
            }
          }), a.onerror = function (e) {
            e.preventDefault(), n(a.error);
          }, a.onsuccess = function () {
            r(a.result), g(e);
          };
        });
      }

      function I(e) {
        return w(e, !1);
      }

      function S(e) {
        return w(e, !0);
      }

      function E(e, t) {
        if (!e.db) return !0;
        var r = !e.db.objectStoreNames.contains(e.storeName),
            n = e.version > e.db.version;

        if (e.version < e.db.version && (e.version !== t && console.warn('The database "' + e.name + "\" can't be downgraded from version " + e.db.version + " to version " + e.version + "."), e.version = e.db.version), n || r) {
          if (r) {
            var o = e.db.version + 1;
            o > e.version && (e.version = o);
          }

          return !0;
        }

        return !1;
      }

      function j(e) {
        return i([m(atob(e.data))], {
          type: e.type
        });
      }

      function A(e) {
        return e && e.__local_forage_encoded_blob;
      }

      function N(e) {
        var t = this,
            r = t._initReady().then(function () {
          var e = h[t._dbInfo.name];
          if (e && e.dbReady) return e.dbReady;
        });

        return c(r, e, e), r;
      }

      function O(e, t, r, n) {
        void 0 === n && (n = 1);

        try {
          var o = e.db.transaction(e.storeName, t);
          r(null, o);
        } catch (o) {
          if (n > 0 && (!e.db || "InvalidStateError" === o.name || "NotFoundError" === o.name)) return a.resolve().then(function () {
            if (!e.db || "NotFoundError" === o.name && !e.db.objectStoreNames.contains(e.storeName) && e.version <= e.db.version) return e.db && (e.version = e.db.version + 1), S(e);
          }).then(function () {
            return function (e) {
              b(e);

              for (var t = h[e.name], r = t.forages, n = 0; n < r.length; n++) {
                var o = r[n];
                o._dbInfo.db && (o._dbInfo.db.close(), o._dbInfo.db = null);
              }

              return e.db = null, I(e).then(function (t) {
                return e.db = t, E(e) ? S(e) : t;
              }).then(function (n) {
                e.db = t.db = n;

                for (var o = 0; o < r.length; o++) {
                  r[o]._dbInfo.db = n;
                }
              }).catch(function (t) {
                throw _(e, t), t;
              });
            }(e).then(function () {
              O(e, t, r, n - 1);
            });
          }).catch(r);
          r(o);
        }
      }

      var x = {
        _driver: "asyncStorage",
        _initStorage: function _initStorage(e) {
          var t = this,
              r = {
            db: null
          };
          if (e) for (var n in e) {
            r[n] = e[n];
          }
          var o = h[r.name];
          o || (h[r.name] = o = {
            forages: [],
            db: null,
            dbReady: null,
            deferredOperations: []
          }), o.forages.push(t), t._initReady || (t._initReady = t.ready, t.ready = N);
          var i = [];

          function u() {
            return a.resolve();
          }

          for (var c = 0; c < o.forages.length; c++) {
            var f = o.forages[c];
            f !== t && i.push(f._initReady().catch(u));
          }

          var s = o.forages.slice(0);
          return a.all(i).then(function () {
            return r.db = o.db, I(r);
          }).then(function (e) {
            return r.db = e, E(r, t._defaultConfig.version) ? S(r) : e;
          }).then(function (e) {
            r.db = o.db = e, t._dbInfo = r;

            for (var n = 0; n < s.length; n++) {
              var i = s[n];
              i !== t && (i._dbInfo.db = r.db, i._dbInfo.version = r.version);
            }
          });
        },
        _support: function () {
          try {
            if (!o || !o.open) return !1;
            var e = "undefined" != typeof openDatabase && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform),
                t = "function" == typeof fetch && -1 !== fetch.toString().indexOf("[native code");
            return (!e || t) && "undefined" != typeof indexedDB && "undefined" != typeof IDBKeyRange;
          } catch (e) {
            return !1;
          }
        }(),
        iterate: function iterate(e, t) {
          var r = this,
              n = new a(function (t, n) {
            r.ready().then(function () {
              O(r._dbInfo, y, function (o, i) {
                if (o) return n(o);

                try {
                  var a = i.objectStore(r._dbInfo.storeName).openCursor(),
                      u = 1;
                  a.onsuccess = function () {
                    var r = a.result;

                    if (r) {
                      var n = r.value;
                      A(n) && (n = j(n));
                      var o = e(n, r.key, u++);
                      void 0 !== o ? t(o) : r.continue();
                    } else t();
                  }, a.onerror = function () {
                    n(a.error);
                  };
                } catch (e) {
                  n(e);
                }
              });
            }).catch(n);
          });
          return u(n, t), n;
        },
        getItem: function getItem(e, t) {
          var r = this;
          e = f(e);
          var n = new a(function (t, n) {
            r.ready().then(function () {
              O(r._dbInfo, y, function (o, i) {
                if (o) return n(o);

                try {
                  var a = i.objectStore(r._dbInfo.storeName).get(e);
                  a.onsuccess = function () {
                    var e = a.result;
                    void 0 === e && (e = null), A(e) && (e = j(e)), t(e);
                  }, a.onerror = function () {
                    n(a.error);
                  };
                } catch (e) {
                  n(e);
                }
              });
            }).catch(n);
          });
          return u(n, t), n;
        },
        setItem: function setItem(e, t, r) {
          var n = this;
          e = f(e);
          var o = new a(function (r, o) {
            var u;
            n.ready().then(function () {
              return u = n._dbInfo, "[object Blob]" === v.call(t) ? function (e) {
                return "boolean" == typeof d ? a.resolve(d) : function (e) {
                  return new a(function (t) {
                    var r = e.transaction(l, p),
                        n = i([""]);
                    r.objectStore(l).put(n, "key"), r.onabort = function (e) {
                      e.preventDefault(), e.stopPropagation(), t(!1);
                    }, r.oncomplete = function () {
                      var e = navigator.userAgent.match(/Chrome\/(\d+)/),
                          r = navigator.userAgent.match(/Edge\//);
                      t(r || !e || parseInt(e[1], 10) >= 43);
                    };
                  }).catch(function () {
                    return !1;
                  });
                }(e).then(function (e) {
                  return d = e;
                });
              }(u.db).then(function (e) {
                return e ? t : (r = t, new a(function (e, t) {
                  var n = new FileReader();
                  n.onerror = t, n.onloadend = function (t) {
                    var n = btoa(t.target.result || "");
                    e({
                      __local_forage_encoded_blob: !0,
                      data: n,
                      type: r.type
                    });
                  }, n.readAsBinaryString(r);
                }));
                var r;
              }) : t;
            }).then(function (t) {
              O(n._dbInfo, p, function (i, a) {
                if (i) return o(i);

                try {
                  var u = a.objectStore(n._dbInfo.storeName);
                  null === t && (t = void 0);
                  var c = u.put(t, e);
                  a.oncomplete = function () {
                    void 0 === t && (t = null), r(t);
                  }, a.onabort = a.onerror = function () {
                    o(c.error ? c.error : c.transaction.error);
                  };
                } catch (e) {
                  o(e);
                }
              });
            }).catch(o);
          });
          return u(o, r), o;
        },
        removeItem: function removeItem(e, t) {
          var r = this;
          e = f(e);
          var n = new a(function (t, n) {
            r.ready().then(function () {
              O(r._dbInfo, p, function (o, i) {
                if (o) return n(o);

                try {
                  var a = i.objectStore(r._dbInfo.storeName).delete(e);
                  i.oncomplete = function () {
                    t();
                  }, i.onerror = function () {
                    n(a.error);
                  }, i.onabort = function () {
                    n(a.error ? a.error : a.transaction.error);
                  };
                } catch (e) {
                  n(e);
                }
              });
            }).catch(n);
          });
          return u(n, t), n;
        },
        clear: function clear(e) {
          var t = this,
              r = new a(function (e, r) {
            t.ready().then(function () {
              O(t._dbInfo, p, function (n, o) {
                if (n) return r(n);

                try {
                  var i = o.objectStore(t._dbInfo.storeName).clear();
                  o.oncomplete = function () {
                    e();
                  }, o.onabort = o.onerror = function () {
                    r(i.error ? i.error : i.transaction.error);
                  };
                } catch (e) {
                  r(e);
                }
              });
            }).catch(r);
          });
          return u(r, e), r;
        },
        length: function length(e) {
          var t = this,
              r = new a(function (e, r) {
            t.ready().then(function () {
              O(t._dbInfo, y, function (n, o) {
                if (n) return r(n);

                try {
                  var i = o.objectStore(t._dbInfo.storeName).count();
                  i.onsuccess = function () {
                    e(i.result);
                  }, i.onerror = function () {
                    r(i.error);
                  };
                } catch (e) {
                  r(e);
                }
              });
            }).catch(r);
          });
          return u(r, e), r;
        },
        key: function key(e, t) {
          var r = this,
              n = new a(function (t, n) {
            e < 0 ? t(null) : r.ready().then(function () {
              O(r._dbInfo, y, function (o, i) {
                if (o) return n(o);

                try {
                  var a = i.objectStore(r._dbInfo.storeName),
                      u = !1,
                      c = a.openKeyCursor();
                  c.onsuccess = function () {
                    var r = c.result;
                    r ? 0 === e || u ? t(r.key) : (u = !0, r.advance(e)) : t(null);
                  }, c.onerror = function () {
                    n(c.error);
                  };
                } catch (e) {
                  n(e);
                }
              });
            }).catch(n);
          });
          return u(n, t), n;
        },
        keys: function keys(e) {
          var t = this,
              r = new a(function (e, r) {
            t.ready().then(function () {
              O(t._dbInfo, y, function (n, o) {
                if (n) return r(n);

                try {
                  var i = o.objectStore(t._dbInfo.storeName).openKeyCursor(),
                      a = [];
                  i.onsuccess = function () {
                    var t = i.result;
                    t ? (a.push(t.key), t.continue()) : e(a);
                  }, i.onerror = function () {
                    r(i.error);
                  };
                } catch (e) {
                  r(e);
                }
              });
            }).catch(r);
          });
          return u(r, e), r;
        },
        dropInstance: function dropInstance(e, t) {
          t = s.apply(this, arguments);
          var r = this.config();
          (e = "function" != typeof e && e || {}).name || (e.name = e.name || r.name, e.storeName = e.storeName || r.storeName);
          var n,
              i = this;

          if (e.name) {
            var c = e.name === r.name && i._dbInfo.db ? a.resolve(i._dbInfo.db) : I(e).then(function (t) {
              var r = h[e.name],
                  n = r.forages;
              r.db = t;

              for (var o = 0; o < n.length; o++) {
                n[o]._dbInfo.db = t;
              }

              return t;
            });
            n = c.then(e.storeName ? function (t) {
              if (t.objectStoreNames.contains(e.storeName)) {
                var r = t.version + 1;
                b(e);
                var n = h[e.name],
                    i = n.forages;
                t.close();

                for (var u = 0; u < i.length; u++) {
                  var c = i[u];
                  c._dbInfo.db = null, c._dbInfo.version = r;
                }

                return new a(function (t, n) {
                  var i = o.open(e.name, r);
                  i.onerror = function (e) {
                    i.result.close(), n(e);
                  }, i.onupgradeneeded = function () {
                    i.result.deleteObjectStore(e.storeName);
                  }, i.onsuccess = function () {
                    var e = i.result;
                    e.close(), t(e);
                  };
                }).then(function (e) {
                  n.db = e;

                  for (var t = 0; t < i.length; t++) {
                    var r = i[t];
                    r._dbInfo.db = e, g(r._dbInfo);
                  }
                }).catch(function (t) {
                  throw (_(e, t) || a.resolve()).catch(function () {}), t;
                });
              }
            } : function (t) {
              b(e);
              var r = h[e.name],
                  n = r.forages;
              t.close();

              for (var i = 0; i < n.length; i++) {
                n[i]._dbInfo.db = null;
              }

              return new a(function (t, r) {
                var n = o.deleteDatabase(e.name);
                n.onerror = n.onblocked = function (e) {
                  var t = n.result;
                  t && t.close(), r(e);
                }, n.onsuccess = function () {
                  var e = n.result;
                  e && e.close(), t(e);
                };
              }).then(function (e) {
                r.db = e;

                for (var t = 0; t < n.length; t++) {
                  g(n[t]._dbInfo);
                }
              }).catch(function (t) {
                throw (_(e, t) || a.resolve()).catch(function () {}), t;
              });
            });
          } else n = a.reject("Invalid arguments");

          return u(n, t), n;
        }
      },
          k = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
          B = /^~~local_forage_type~([^~]+)~/,
          L = "__lfsc__:",
          R = L.length,
          D = "arbf",
          C = "blob",
          T = "si08",
          P = "ui08",
          F = "uic8",
          M = "si16",
          z = "si32",
          U = "ur16",
          q = "ui32",
          W = "fl32",
          G = "fl64",
          H = R + D.length,
          K = Object.prototype.toString;

      function J(e) {
        var t,
            r,
            n,
            o,
            i,
            a = .75 * e.length,
            u = e.length,
            c = 0;
        "=" === e[e.length - 1] && (a--, "=" === e[e.length - 2] && a--);
        var f = new ArrayBuffer(a),
            s = new Uint8Array(f);

        for (t = 0; t < u; t += 4) {
          r = k.indexOf(e[t]), n = k.indexOf(e[t + 1]), o = k.indexOf(e[t + 2]), i = k.indexOf(e[t + 3]), s[c++] = r << 2 | n >> 4, s[c++] = (15 & n) << 4 | o >> 2, s[c++] = (3 & o) << 6 | 63 & i;
        }

        return f;
      }

      function Q(e) {
        var t,
            r = new Uint8Array(e),
            n = "";

        for (t = 0; t < r.length; t += 3) {
          n += k[r[t] >> 2], n += k[(3 & r[t]) << 4 | r[t + 1] >> 4], n += k[(15 & r[t + 1]) << 2 | r[t + 2] >> 6], n += k[63 & r[t + 2]];
        }

        return r.length % 3 == 2 ? n = n.substring(0, n.length - 1) + "=" : r.length % 3 == 1 && (n = n.substring(0, n.length - 2) + "=="), n;
      }

      var X = {
        serialize: function serialize(e, t) {
          var r = "";

          if (e && (r = K.call(e)), e && ("[object ArrayBuffer]" === r || e.buffer && "[object ArrayBuffer]" === K.call(e.buffer))) {
            var n,
                o = L;
            e instanceof ArrayBuffer ? (n = e, o += D) : (n = e.buffer, "[object Int8Array]" === r ? o += T : "[object Uint8Array]" === r ? o += P : "[object Uint8ClampedArray]" === r ? o += F : "[object Int16Array]" === r ? o += M : "[object Uint16Array]" === r ? o += U : "[object Int32Array]" === r ? o += z : "[object Uint32Array]" === r ? o += q : "[object Float32Array]" === r ? o += W : "[object Float64Array]" === r ? o += G : t(new Error("Failed to get type for BinaryArray"))), t(o + Q(n));
          } else if ("[object Blob]" === r) {
            var i = new FileReader();
            i.onload = function () {
              var r = "~~local_forage_type~" + e.type + "~" + Q(this.result);
              t("__lfsc__:blob" + r);
            }, i.readAsArrayBuffer(e);
          } else try {
            t(JSON.stringify(e));
          } catch (r) {
            console.error("Couldn't convert value into a JSON string: ", e), t(null, r);
          }
        },
        deserialize: function deserialize(e) {
          if (e.substring(0, R) !== L) return JSON.parse(e);
          var t,
              r = e.substring(H),
              n = e.substring(R, H);

          if (n === C && B.test(r)) {
            var o = r.match(B);
            t = o[1], r = r.substring(o[0].length);
          }

          var a = J(r);

          switch (n) {
            case D:
              return a;

            case C:
              return i([a], {
                type: t
              });

            case T:
              return new Int8Array(a);

            case P:
              return new Uint8Array(a);

            case F:
              return new Uint8ClampedArray(a);

            case M:
              return new Int16Array(a);

            case U:
              return new Uint16Array(a);

            case z:
              return new Int32Array(a);

            case q:
              return new Uint32Array(a);

            case W:
              return new Float32Array(a);

            case G:
              return new Float64Array(a);

            default:
              throw new Error("Unkown type: " + n);
          }
        },
        stringToBuffer: J,
        bufferToString: Q
      };

      function V(e, t, r, n) {
        e.executeSql("CREATE TABLE IF NOT EXISTS " + t.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], r, n);
      }

      function Y(e, t, r, n, o, i) {
        e.executeSql(r, n, o, function (e, a) {
          a.code === a.SYNTAX_ERR ? e.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [t.storeName], function (e, u) {
            u.rows.length ? i(e, a) : V(e, t, function () {
              e.executeSql(r, n, o, i);
            }, i);
          }, i) : i(e, a);
        }, i);
      }

      function Z(e, t, r, n) {
        var o = this;
        e = f(e);
        var i = new a(function (i, a) {
          o.ready().then(function () {
            void 0 === t && (t = null);
            var u = t,
                c = o._dbInfo;
            c.serializer.serialize(t, function (t, f) {
              f ? a(f) : c.db.transaction(function (r) {
                Y(r, c, "INSERT OR REPLACE INTO " + c.storeName + " (key, value) VALUES (?, ?)", [e, t], function () {
                  i(u);
                }, function (e, t) {
                  a(t);
                });
              }, function (t) {
                if (t.code === t.QUOTA_ERR) {
                  if (n > 0) return void i(Z.apply(o, [e, u, r, n - 1]));
                  a(t);
                }
              });
            });
          }).catch(a);
        });
        return u(i, r), i;
      }

      function $(e) {
        return new a(function (t, r) {
          e.transaction(function (n) {
            n.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (r, n) {
              for (var o = [], i = 0; i < n.rows.length; i++) {
                o.push(n.rows.item(i).name);
              }

              t({
                db: e,
                storeNames: o
              });
            }, function (e, t) {
              r(t);
            });
          }, function (e) {
            r(e);
          });
        });
      }

      var ee = {
        _driver: "webSQLStorage",
        _initStorage: function _initStorage(e) {
          var t = this,
              r = {
            db: null
          };
          if (e) for (var n in e) {
            r[n] = "string" != typeof e[n] ? e[n].toString() : e[n];
          }
          var o = new a(function (e, n) {
            try {
              r.db = openDatabase(r.name, String(r.version), r.description, r.size);
            } catch (e) {
              return n(e);
            }

            r.db.transaction(function (o) {
              V(o, r, function () {
                t._dbInfo = r, e();
              }, function (e, t) {
                n(t);
              });
            }, n);
          });
          return r.serializer = X, o;
        },
        _support: "function" == typeof openDatabase,
        iterate: function iterate(e, t) {
          var r = this,
              n = new a(function (t, n) {
            r.ready().then(function () {
              var o = r._dbInfo;
              o.db.transaction(function (r) {
                Y(r, o, "SELECT * FROM " + o.storeName, [], function (r, n) {
                  for (var i = n.rows, a = i.length, u = 0; u < a; u++) {
                    var c = i.item(u),
                        f = c.value;
                    if (f && (f = o.serializer.deserialize(f)), void 0 !== (f = e(f, c.key, u + 1))) return void t(f);
                  }

                  t();
                }, function (e, t) {
                  n(t);
                });
              });
            }).catch(n);
          });
          return u(n, t), n;
        },
        getItem: function getItem(e, t) {
          var r = this;
          e = f(e);
          var n = new a(function (t, n) {
            r.ready().then(function () {
              var o = r._dbInfo;
              o.db.transaction(function (r) {
                Y(r, o, "SELECT * FROM " + o.storeName + " WHERE key = ? LIMIT 1", [e], function (e, r) {
                  var n = r.rows.length ? r.rows.item(0).value : null;
                  n && (n = o.serializer.deserialize(n)), t(n);
                }, function (e, t) {
                  n(t);
                });
              });
            }).catch(n);
          });
          return u(n, t), n;
        },
        setItem: function setItem(e, t, r) {
          return Z.apply(this, [e, t, r, 1]);
        },
        removeItem: function removeItem(e, t) {
          var r = this;
          e = f(e);
          var n = new a(function (t, n) {
            r.ready().then(function () {
              var o = r._dbInfo;
              o.db.transaction(function (r) {
                Y(r, o, "DELETE FROM " + o.storeName + " WHERE key = ?", [e], function () {
                  t();
                }, function (e, t) {
                  n(t);
                });
              });
            }).catch(n);
          });
          return u(n, t), n;
        },
        clear: function clear(e) {
          var t = this,
              r = new a(function (e, r) {
            t.ready().then(function () {
              var n = t._dbInfo;
              n.db.transaction(function (t) {
                Y(t, n, "DELETE FROM " + n.storeName, [], function () {
                  e();
                }, function (e, t) {
                  r(t);
                });
              });
            }).catch(r);
          });
          return u(r, e), r;
        },
        length: function length(e) {
          var t = this,
              r = new a(function (e, r) {
            t.ready().then(function () {
              var n = t._dbInfo;
              n.db.transaction(function (t) {
                Y(t, n, "SELECT COUNT(key) as c FROM " + n.storeName, [], function (t, r) {
                  var n = r.rows.item(0).c;
                  e(n);
                }, function (e, t) {
                  r(t);
                });
              });
            }).catch(r);
          });
          return u(r, e), r;
        },
        key: function key(e, t) {
          var r = this,
              n = new a(function (t, n) {
            r.ready().then(function () {
              var o = r._dbInfo;
              o.db.transaction(function (r) {
                Y(r, o, "SELECT key FROM " + o.storeName + " WHERE id = ? LIMIT 1", [e + 1], function (e, r) {
                  var n = r.rows.length ? r.rows.item(0).key : null;
                  t(n);
                }, function (e, t) {
                  n(t);
                });
              });
            }).catch(n);
          });
          return u(n, t), n;
        },
        keys: function keys(e) {
          var t = this,
              r = new a(function (e, r) {
            t.ready().then(function () {
              var n = t._dbInfo;
              n.db.transaction(function (t) {
                Y(t, n, "SELECT key FROM " + n.storeName, [], function (t, r) {
                  for (var n = [], o = 0; o < r.rows.length; o++) {
                    n.push(r.rows.item(o).key);
                  }

                  e(n);
                }, function (e, t) {
                  r(t);
                });
              });
            }).catch(r);
          });
          return u(r, e), r;
        },
        dropInstance: function dropInstance(e, t) {
          t = s.apply(this, arguments);
          var r = this.config();
          (e = "function" != typeof e && e || {}).name || (e.name = e.name || r.name, e.storeName = e.storeName || r.storeName);
          var n,
              o = this;
          return u(n = e.name ? new a(function (t) {
            var n;
            n = e.name === r.name ? o._dbInfo.db : openDatabase(e.name, "", "", 0), t(e.storeName ? {
              db: n,
              storeNames: [e.storeName]
            } : $(n));
          }).then(function (e) {
            return new a(function (t, r) {
              e.db.transaction(function (n) {
                function o(e) {
                  return new a(function (t, r) {
                    n.executeSql("DROP TABLE IF EXISTS " + e, [], function () {
                      t();
                    }, function (e, t) {
                      r(t);
                    });
                  });
                }

                for (var i = [], u = 0, c = e.storeNames.length; u < c; u++) {
                  i.push(o(e.storeNames[u]));
                }

                a.all(i).then(function () {
                  t();
                }).catch(function (e) {
                  r(e);
                });
              }, function (e) {
                r(e);
              });
            });
          }) : a.reject("Invalid arguments"), t), n;
        }
      };

      function te(e, t) {
        var r = e.name + "/";
        return e.storeName !== t.storeName && (r += e.storeName + "/"), r;
      }

      var re = {
        _driver: "localStorageWrapper",
        _initStorage: function _initStorage(e) {
          var t = {};
          if (e) for (var r in e) {
            t[r] = e[r];
          }
          return t.keyPrefix = te(e, this._defaultConfig), !function () {
            var e = "_localforage_support_test";

            try {
              return localStorage.setItem(e, !0), localStorage.removeItem(e), !1;
            } catch (e) {
              return !0;
            }
          }() || localStorage.length > 0 ? (this._dbInfo = t, t.serializer = X, a.resolve()) : a.reject();
        },
        _support: function () {
          try {
            return "undefined" != typeof localStorage && "setItem" in localStorage && !!localStorage.setItem;
          } catch (e) {
            return !1;
          }
        }(),
        iterate: function iterate(e, t) {
          var r = this,
              n = r.ready().then(function () {
            for (var t = r._dbInfo, n = t.keyPrefix, o = n.length, i = localStorage.length, a = 1, u = 0; u < i; u++) {
              var c = localStorage.key(u);

              if (0 === c.indexOf(n)) {
                var f = localStorage.getItem(c);
                if (f && (f = t.serializer.deserialize(f)), void 0 !== (f = e(f, c.substring(o), a++))) return f;
              }
            }
          });
          return u(n, t), n;
        },
        getItem: function getItem(e, t) {
          var r = this;
          e = f(e);
          var n = r.ready().then(function () {
            var t = r._dbInfo,
                n = localStorage.getItem(t.keyPrefix + e);
            return n && (n = t.serializer.deserialize(n)), n;
          });
          return u(n, t), n;
        },
        setItem: function setItem(e, t, r) {
          var n = this;
          e = f(e);
          var o = n.ready().then(function () {
            void 0 === t && (t = null);
            var r = t;
            return new a(function (o, i) {
              var a = n._dbInfo;
              a.serializer.serialize(t, function (t, n) {
                if (n) i(n);else try {
                  localStorage.setItem(a.keyPrefix + e, t), o(r);
                } catch (e) {
                  "QuotaExceededError" !== e.name && "NS_ERROR_DOM_QUOTA_REACHED" !== e.name || i(e), i(e);
                }
              });
            });
          });
          return u(o, r), o;
        },
        removeItem: function removeItem(e, t) {
          var r = this;
          e = f(e);
          var n = r.ready().then(function () {
            localStorage.removeItem(r._dbInfo.keyPrefix + e);
          });
          return u(n, t), n;
        },
        clear: function clear(e) {
          var t = this,
              r = t.ready().then(function () {
            for (var e = t._dbInfo.keyPrefix, r = localStorage.length - 1; r >= 0; r--) {
              var n = localStorage.key(r);
              0 === n.indexOf(e) && localStorage.removeItem(n);
            }
          });
          return u(r, e), r;
        },
        length: function length(e) {
          var t = this.keys().then(function (e) {
            return e.length;
          });
          return u(t, e), t;
        },
        key: function key(e, t) {
          var r = this,
              n = r.ready().then(function () {
            var t,
                n = r._dbInfo;

            try {
              t = localStorage.key(e);
            } catch (e) {
              t = null;
            }

            return t && (t = t.substring(n.keyPrefix.length)), t;
          });
          return u(n, t), n;
        },
        keys: function keys(e) {
          var t = this,
              r = t.ready().then(function () {
            for (var e = t._dbInfo, r = localStorage.length, n = [], o = 0; o < r; o++) {
              var i = localStorage.key(o);
              0 === i.indexOf(e.keyPrefix) && n.push(i.substring(e.keyPrefix.length));
            }

            return n;
          });
          return u(r, e), r;
        },
        dropInstance: function dropInstance(e, t) {
          if (t = s.apply(this, arguments), !(e = "function" != typeof e && e || {}).name) {
            var r = this.config();
            e.name = e.name || r.name, e.storeName = e.storeName || r.storeName;
          }

          var n,
              o = this;
          return u(n = e.name ? new a(function (t) {
            t(e.storeName ? te(e, o._defaultConfig) : e.name + "/");
          }).then(function (e) {
            for (var t = localStorage.length - 1; t >= 0; t--) {
              var r = localStorage.key(t);
              0 === r.indexOf(e) && localStorage.removeItem(r);
            }
          }) : a.reject("Invalid arguments"), t), n;
        }
      },
          ne = function ne(e, t) {
        for (var r = e.length, n = 0; n < r;) {
          if ((o = e[n]) === (i = t) || "number" == typeof o && "number" == typeof i && isNaN(o) && isNaN(i)) return !0;
          n++;
        }

        var o, i;
        return !1;
      },
          oe = Array.isArray || function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      },
          ie = {},
          ae = {},
          ue = {
        INDEXEDDB: x,
        WEBSQL: ee,
        LOCALSTORAGE: re
      },
          ce = [ue.INDEXEDDB._driver, ue.WEBSQL._driver, ue.LOCALSTORAGE._driver],
          fe = ["dropInstance"],
          se = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(fe),
          le = {
        description: "",
        driver: ce.slice(),
        name: "localforage",
        size: 4980736,
        storeName: "keyvaluepairs",
        version: 1
      };

      function de(e, t) {
        e[t] = function () {
          var r = arguments;
          return e.ready().then(function () {
            return e[t].apply(e, r);
          });
        };
      }

      function he() {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          if (t) for (var r in t) {
            t.hasOwnProperty(r) && (arguments[0][r] = oe(t[r]) ? t[r].slice() : t[r]);
          }
        }

        return arguments[0];
      }

      var ve = new (function () {
        function e(t) {
          for (var r in function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), ue) {
            if (ue.hasOwnProperty(r)) {
              var n = ue[r],
                  o = n._driver;
              this[r] = o, ie[o] || this.defineDriver(n);
            }
          }

          this._defaultConfig = he({}, le), this._config = he({}, this._defaultConfig, t), this._driverSet = null, this._initDriver = null, this._ready = !1, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver).catch(function () {});
        }

        return e.prototype.config = function (e) {
          if ("object" === (void 0 === e ? "undefined" : n(e))) {
            if (this._ready) return new Error("Can't call config() after localforage has been used.");

            for (var t in e) {
              if ("storeName" === t && (e[t] = e[t].replace(/\W/g, "_")), "version" === t && "number" != typeof e[t]) return new Error("Database version must be a number.");
              this._config[t] = e[t];
            }

            return !("driver" in e) || !e.driver || this.setDriver(this._config.driver);
          }

          return "string" == typeof e ? this._config[e] : this._config;
        }, e.prototype.defineDriver = function (e, t, r) {
          var n = new a(function (t, r) {
            try {
              var n = e._driver,
                  o = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
              if (!e._driver) return void r(o);

              for (var i = se.concat("_initStorage"), c = 0, f = i.length; c < f; c++) {
                var s = i[c];
                if ((!ne(fe, s) || e[s]) && "function" != typeof e[s]) return void r(o);
              }

              !function () {
                for (var t = function t(e) {
                  return function () {
                    var t = new Error("Method " + e + " is not implemented by the current driver"),
                        r = a.reject(t);
                    return u(r, arguments[arguments.length - 1]), r;
                  };
                }, r = 0, n = fe.length; r < n; r++) {
                  var o = fe[r];
                  e[o] || (e[o] = t(o));
                }
              }();

              var l = function l(r) {
                ie[n] && console.info("Redefining LocalForage driver: " + n), ie[n] = e, ae[n] = r, t();
              };

              "_support" in e ? e._support && "function" == typeof e._support ? e._support().then(l, r) : l(!!e._support) : l(!0);
            } catch (e) {
              r(e);
            }
          });
          return c(n, t, r), n;
        }, e.prototype.driver = function () {
          return this._driver || null;
        }, e.prototype.getDriver = function (e, t, r) {
          var n = ie[e] ? a.resolve(ie[e]) : a.reject(new Error("Driver not found."));
          return c(n, t, r), n;
        }, e.prototype.getSerializer = function (e) {
          var t = a.resolve(X);
          return c(t, e), t;
        }, e.prototype.ready = function (e) {
          var t = this,
              r = t._driverSet.then(function () {
            return null === t._ready && (t._ready = t._initDriver()), t._ready;
          });

          return c(r, e, e), r;
        }, e.prototype.setDriver = function (e, t, r) {
          var n = this;
          oe(e) || (e = [e]);

          var o = this._getSupportedDrivers(e);

          function i() {
            n._config.driver = n.driver();
          }

          function u(e) {
            return n._extend(e), i(), n._ready = n._initStorage(n._config), n._ready;
          }

          var f = null !== this._driverSet ? this._driverSet.catch(function () {
            return a.resolve();
          }) : a.resolve();
          return this._driverSet = f.then(function () {
            var e = o[0];
            return n._dbInfo = null, n._ready = null, n.getDriver(e).then(function (e) {
              n._driver = e._driver, i(), n._wrapLibraryMethodsWithReady(), n._initDriver = function (e) {
                return function () {
                  var t = 0;
                  return function r() {
                    for (; t < e.length;) {
                      var o = e[t];
                      return t++, n._dbInfo = null, n._ready = null, n.getDriver(o).then(u).catch(r);
                    }

                    i();
                    var c = new Error("No available storage method found.");
                    return n._driverSet = a.reject(c), n._driverSet;
                  }();
                };
              }(o);
            });
          }).catch(function () {
            i();
            var e = new Error("No available storage method found.");
            return n._driverSet = a.reject(e), n._driverSet;
          }), c(this._driverSet, t, r), this._driverSet;
        }, e.prototype.supports = function (e) {
          return !!ae[e];
        }, e.prototype._extend = function (e) {
          he(this, e);
        }, e.prototype._getSupportedDrivers = function (e) {
          for (var t = [], r = 0, n = e.length; r < n; r++) {
            var o = e[r];
            this.supports(o) && t.push(o);
          }

          return t;
        }, e.prototype._wrapLibraryMethodsWithReady = function () {
          for (var e = 0, t = se.length; e < t; e++) {
            de(this, se[e]);
          }
        }, e.prototype.createInstance = function (t) {
          return new e(t);
        }, e;
      }())();
      t.exports = ve;
    }, {
      3: 3
    }]
  }, {}, [4])(4);
}),
    l = c(function (e, t) {
  "undefined" != typeof self && self, function (e) {
    var t = /^~~local_forage_type~([^~]+)~/,
        r = "__lfsc__:".length,
        n = r + "arbf".length,
        o = Object.prototype.toString;

    function i(e) {
      var t = .75 * e.length,
          r = e.length;
      "=" === e[e.length - 1] && (t--, "=" === e[e.length - 2] && t--);

      for (var n = new ArrayBuffer(t), o = new Uint8Array(n), i = 0, a = 0; i < r; i += 4) {
        var u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(e[i]),
            c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(e[i + 1]),
            f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(e[i + 2]),
            s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(e[i + 3]);
        o[a++] = u << 2 | c >> 4, o[a++] = (15 & c) << 4 | f >> 2, o[a++] = (3 & f) << 6 | 63 & s;
      }

      return n;
    }

    function a(e) {
      for (var t = new Uint8Array(e), r = "", n = 0; n < t.length; n += 3) {
        r += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[t[n] >> 2], r += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(3 & t[n]) << 4 | t[n + 1] >> 4], r += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(15 & t[n + 1]) << 2 | t[n + 2] >> 6], r += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[63 & t[n + 2]];
      }

      return t.length % 3 == 2 ? r = r.substring(0, r.length - 1) + "=" : t.length % 3 == 1 && (r = r.substring(0, r.length - 2) + "=="), r;
    }

    function u(e) {
      var t, r;
      if (null === e || "object" != _typeof(e) || "isActiveClone" in e) return e;
      var n = e instanceof Date ? new Date(e) : e.constructor();

      try {
        for (var o = function (e) {
          var t = "function" == typeof Symbol && e[Symbol.iterator],
              r = 0;
          return t ? t.call(e) : {
            next: function next() {
              return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
              };
            }
          };
        }(Object.keys(e)), i = o.next(); !i.done; i = o.next()) {
          var a = i.value;
          Object.prototype.hasOwnProperty.call(e, a) && (e.isActiveClone = null, n[a] = u(e[a]), delete e.isActiveClone);
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          i && !i.done && (r = o.return) && r.call(o);
        } finally {
          if (t) throw t.error;
        }
      }

      return n;
    }

    function c(e, t) {
      return (e.name || t.name) + "/" + (e.storeName || t.storeName) + "/";
    }

    function f(e, t) {
      t && e.then(function (e) {
        t(null, e);
      }, function (e) {
        t(e);
      });
    }

    function s() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }

      if (arguments.length && "function" == typeof arguments[arguments.length - 1]) return arguments[arguments.length - 1];
    }

    function l(e, t) {
      var r = this;

      if (t = s.apply(this, arguments), !(e = "function" != typeof e && e || {}).name) {
        var n = this.config();
        e.name = e.name || n.name, e.storeName = e.storeName || n.storeName;
      }

      return {
        promise: e.name ? new Promise(function (t) {
          t(e.storeName ? c(e, r._defaultConfig) : e.name + "/");
        }) : Promise.reject("Invalid arguments"),
        callback: t
      };
    }

    function d(e) {
      return "string" != typeof e && (console.warn(e + " used as a key, but it is not a string."), e = String(e)), e;
    }

    var h = {
      bufferToString: a,
      deserialize: function deserialize(e) {
        if ("__lfsc__:" !== e.substring(0, r)) return JSON.parse(e);
        var o,
            a = e.substring(n),
            u = e.substring(r, n);

        if ("blob" === u && t.test(a)) {
          var c = a.match(t);
          o = c[1], a = a.substring(c[0].length);
        }

        var f = i(a);

        switch (u) {
          case "arbf":
            return f;

          case "blob":
            return function (e, t) {
              e = e || [], t = t || {};

              try {
                return new Blob(e, t);
              } catch (o) {
                if ("TypeError" !== o.name) throw o;

                for (var r = new ("undefined" != typeof BlobBuilder ? BlobBuilder : "undefined" != typeof MSBlobBuilder ? MSBlobBuilder : "undefined" != typeof MozBlobBuilder ? MozBlobBuilder : WebKitBlobBuilder)(), n = 0; n < e.length; n += 1) {
                  r.append(e[n]);
                }

                return r.getBlob(t.type);
              }
            }([f], {
              type: o
            });

          case "si08":
            return new Int8Array(f);

          case "ui08":
            return new Uint8Array(f);

          case "uic8":
            return new Uint8ClampedArray(f);

          case "si16":
            return new Int16Array(f);

          case "ur16":
            return new Uint16Array(f);

          case "si32":
            return new Int32Array(f);

          case "ui32":
            return new Uint32Array(f);

          case "fl32":
            return new Float32Array(f);

          case "fl64":
            return new Float64Array(f);

          default:
            throw new Error("Unkown type: " + u);
        }
      },
      serialize: function serialize(e, t) {
        var r = "";

        if (e && (r = o.call(e)), e && ("[object ArrayBuffer]" === r || e.buffer && "[object ArrayBuffer]" === o.call(e.buffer))) {
          var n = void 0,
              i = "__lfsc__:";
          e instanceof ArrayBuffer ? (n = e, i += "arbf") : (n = e.buffer, "[object Int8Array]" === r ? i += "si08" : "[object Uint8Array]" === r ? i += "ui08" : "[object Uint8ClampedArray]" === r ? i += "uic8" : "[object Int16Array]" === r ? i += "si16" : "[object Uint16Array]" === r ? i += "ur16" : "[object Int32Array]" === r ? i += "si32" : "[object Uint32Array]" === r ? i += "ui32" : "[object Float32Array]" === r ? i += "fl32" : "[object Float64Array]" === r ? i += "fl64" : t(new Error("Failed to get type for BinaryArray"))), t(i + a(n));
        } else if ("[object Blob]" === r) {
          var u = new FileReader();
          u.onload = function () {
            var r = "~~local_forage_type~" + e.type + "~" + a(this.result);
            t("__lfsc__:blob" + r);
          }, u.readAsArrayBuffer(e);
        } else try {
          t(JSON.stringify(e));
        } catch (r) {
          console.error("Couldn't convert value into a JSON string: ", e), t(null, r);
        }
      },
      stringToBuffer: i
    },
        v = {},
        y = function () {
      function e(e) {
        this.kp = e, this.data = {};
      }

      return e.resolve = function (t) {
        return v[t] || (v[t] = new e(t)), v[t];
      }, e.prototype.clear = function () {
        this.data = {};
      }, e.prototype.drop = function () {
        this.clear(), delete v[this.kp];
      }, e.prototype.get = function (e) {
        return this.data[e];
      }, e.prototype.key = function (e) {
        return this.keys()[e];
      }, e.prototype.keys = function () {
        return Object.keys(this.data);
      }, e.prototype.rm = function (e) {
        delete this.data[e];
      }, e.prototype.set = function (e, t) {
        this.data[e] = t;
      }, e;
    }();

    e._support = !0, e._driver = "localforage-driver-memory", e._initStorage = function (e) {
      var t = e ? u(e) : {},
          r = c(t, this._defaultConfig),
          n = y.resolve(r);
      return this._dbInfo = t, this._dbInfo.serializer = h, this._dbInfo.keyPrefix = r, this._dbInfo.mStore = n, Promise.resolve();
    }, e.clear = function (e) {
      var t = this,
          r = this.ready().then(function () {
        t._dbInfo.mStore.clear();
      });
      return f(r, e), r;
    }, e.dropInstance = function (e, t) {
      var r = l.apply(this, arguments),
          n = r.promise,
          o = r.callback;
      return f(n.then(function (e) {
        y.resolve(e).drop();
      }), o), n;
    }, e.getItem = function (e, t) {
      var r = this;
      e = d(e);
      var n = this.ready().then(function () {
        var t = r._dbInfo.mStore.get(e);

        return null == t ? null : r._dbInfo.serializer.deserialize(t);
      });
      return f(n, t), n;
    }, e.iterate = function (e, t) {
      var r = this,
          n = this.ready().then(function () {
        for (var t = r._dbInfo.mStore, n = t.keys(), o = 0; o < n.length; o++) {
          var i = t.get(n[o]);
          if (i && (i = r._dbInfo.serializer.deserialize(i)), void 0 !== (i = e(i, n[o], o + 1))) return i;
        }
      });
      return f(n, t), n;
    }, e.key = function (e, t) {
      var r = this,
          n = this.ready().then(function () {
        var t;

        try {
          void 0 === (t = r._dbInfo.mStore.key(e)) && (t = null);
        } catch (e) {
          t = null;
        }

        return t;
      });
      return f(n, t), n;
    }, e.keys = function (e) {
      var t = this,
          r = this.ready().then(function () {
        return t._dbInfo.mStore.keys();
      });
      return f(r, e), r;
    }, e.length = function (e) {
      var t = this.keys().then(function (e) {
        return e.length;
      });
      return f(t, e), t;
    }, e.removeItem = function (e, t) {
      var r = this;
      e = d(e);
      var n = this.ready().then(function () {
        r._dbInfo.mStore.rm(e);
      });
      return f(n, t), n;
    }, e.setItem = function (e, t, r) {
      var n = this;
      e = d(e);
      var o = this.ready().then(function () {
        void 0 === t && (t = null);
        var r = t;
        return new Promise(function (o, i) {
          n._dbInfo.serializer.serialize(t, function (t, a) {
            if (a) i(a);else try {
              n._dbInfo.mStore.set(e, t), o(r);
            } catch (e) {
              i(e);
            }
          });
        });
      });
      return f(o, r), o;
    }, Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }(t);
}),
    d = u(l),
    h = Object.assign(Object.create(null), l, {
  default: d
});

function v(e, t) {
  return (v = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function y(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }

  return n;
}

var p = {
  display: "none",
  position: "fixed",
  top: "0",
  right: "0",
  width: "100%",
  height: "100%",
  borderRadius: "0",
  border: "none",
  zIndex: "2147483647"
},
    m = o(i, {
  platform: "web",
  sdkName: "magic-sdk",
  version: "7.0.0",
  defaultEndpoint: "https://auth.magic.link/",
  ViewController: function (n) {
    var o, i;

    function a() {
      for (var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++) {
        r[o] = arguments[o];
      }

      return (e = n.call.apply(n, [this].concat(r)) || this).iframe = void 0, e.activeElement = null, e;
    }

    i = n, (o = a).prototype = Object.create(i.prototype), o.prototype.constructor = o, v(o, i);
    var u = a.prototype;
    return u.init = function () {
      var e = this;
      this.test = "hello", this.iframe = new Promise(function (n) {
        var o = function o() {
          if (i = encodeURIComponent(e.parameters), a = [].slice.call(document.querySelectorAll(".magic-iframe")), Boolean(a.find(function (e) {
            return e.src.includes(i);
          }))) r().log();else {
            var o = document.createElement("iframe");
            o.classList.add("magic-iframe"), o.dataset.magicIframeLabel = t(e.endpoint).host, o.title = "Secure Modal", o.src = t("/send?params=" + encodeURIComponent(e.parameters), e.endpoint).href, function (e) {
              for (var t = 0, r = Object.entries(p); t < r.length; t++) {
                var n = r[t];
                e.style[n[0]] = n[1];
              }
            }(o), document.body.appendChild(o), n(o);
          }
          var i, a;
        };

        ["loaded", "interactive", "complete"].includes(document.readyState) ? o() : window.addEventListener("load", o, !1);
      }), window.addEventListener("message", function (t) {
        if (t.origin === e.endpoint && t.data && t.data.msgType && e.messageHandlers.size) {
          var r;
          t.data.response = null != (r = t.data.response) ? r : {};

          for (var n, o = function (e, t) {
            var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (r) return (r = r.call(e)).next.bind(r);

            if (Array.isArray(e) || (r = function (e, t) {
              if (e) {
                if ("string" == typeof e) return y(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? y(e, t) : void 0;
              }
            }(e))) {
              r && (e = r);
              var n = 0;
              return function () {
                return n >= e.length ? {
                  done: !0
                } : {
                  done: !1,
                  value: e[n++]
                };
              };
            }

            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }(e.messageHandlers.values()); !(n = o()).done;) {
            (0, n.value)(t);
          }
        }
      });
    }, u.showOverlay = function () {
      try {
        var e = this;
        return Promise.resolve(e.iframe).then(function (t) {
          t.style.display = "block", e.activeElement = document.activeElement, t.focus();
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }, u.hideOverlay = function () {
      try {
        var e = this;
        return Promise.resolve(e.iframe).then(function (t) {
          var r;
          t.style.display = "none", null !== (r = e.activeElement) && void 0 !== r && r.focus && e.activeElement.focus(), e.activeElement = null;
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }, u._post = function (t) {
      try {
        var r = this;
        return Promise.resolve(r.iframe).then(function (n) {
          if (!n || !n.contentWindow) throw e();
          n.contentWindow.postMessage(t, r.endpoint);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }, a;
  }(n),
  configureStorage: function configureStorage() {
    try {
      var e = s.createInstance({
        name: "MagicAuthLocalStorageDB",
        storeName: "MagicAuthLocalStorage"
      });
      return Promise.resolve(e.defineDriver(h)).then(function () {
        return Promise.resolve(e.setDriver([s.INDEXEDDB, s.LOCALSTORAGE, l._driver])).then(function () {
          return e;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }
});
export { m as Magic };